import React from 'react';
import icon from '@images/wysiwyg_editor/toolbox_icons/text.svg';
import closeIcon from '@images/wysiwyg_editor/toolbox_icons/close.svg';
import DrawerHeader from '@src/components/wysiwyg_editor/toolbox/DrawerHeader';


type TProps = {
  children: React.ReactNode;
  onClick: () => void;
};
export function Text(props: TProps) {
  return (
    <DrawerHeader>
      <img src={icon} />
      <span style={{ marginLeft: '2rem' }}>Text</span>
      <img
        src={closeIcon}
        style={{ marginLeft: 'auto' }}
        onClick={props.onClick}
      />
      {props.children}
    </DrawerHeader>
  );
}

export default Text;
